/* CHANGE TAB DESKTOP*/
document.querySelectorAll("header-nav ul li").forEach((item) => {
  item.addEventListener("click", (e) => {

    document.querySelectorAll("header-nav ul li").forEach(e => {
      e.classList.remove("active")
    })
    e.target.classList.add("active")

    let currView = e.target.dataset.view
    console.log(currView)
    document.querySelectorAll(".wrapper-container-popup .views .view").forEach(e => {
      e.classList.remove("active")
    })
    document.querySelector(`.wrapper-container-popup .views .view-${currView}`).classList.add("active")
  });
});

/* CHANGE TAB MOBILE*/
document.getElementById("size-chart-redesign-measurement-input").addEventListener("change", (e) => {
  console.log(e.target.value)
  document.querySelectorAll(".wrapper-container-popup .views .view").forEach(e => {
    e.classList.remove("active")
  })
  document.querySelector(`.wrapper-container-popup .views .view-${e.target.value}`).classList.add("active")
});

/* OPEN && CLOSE POPUP */
document.querySelectorAll(".container-popup .close").forEach((item) => {
  item.addEventListener("click", (e) => {
    document.querySelector("body").classList.remove("open-popup")
  });
});

document.getElementById("active-size").addEventListener("click", (e) => {
  document.querySelector("body").classList.add("open-popup")
});

document.addEventListener("DOMContentLoaded", function(event) {
  let sizeInsert = document.querySelector(".template-product .product__description table") 
  if(sizeInsert != ""){
    let container = document.querySelector("#popup--wrapper")     
      container.innerHTML = ""
      container.append(sizeInsert)      
  }
});

/* FUNCTIONS POPUP */
document.querySelectorAll(".wrapper-container-popup .info-wrapper .swatch li").forEach((item) => {
  item.addEventListener("click", (e) => {
    let curr = e.target.parentElement
    let activeLi = document.querySelectorAll(`.info-wrapper .swatch.${curr.dataset.type} li`)
    let currInfo = e.target.innerText.toLowerCase()

    activeLi.forEach(e => {
      e.classList.remove("active")
    })
    e.target.classList.add("active");

    if(curr.dataset.type == "extent"){     
      document.querySelectorAll(".inf-bottom").forEach((item) => { 
        item.classList.remove("active")
      })
      document.querySelector(`.info-bottom .inf-bottom.${currInfo}`).classList.add("active")
    }

    let currExtent = document.querySelector(".swatch.extent li.active").innerText.toLowerCase()
    let currSize = document.querySelector(".swatch.size li.active").dataset[currExtent]
        currSize = currSize.split(",")
  
        document.querySelector(".views .img-wrapper span.top").innerHTML = `${currSize[0]}`
        document.querySelector(".views .img-wrapper span.left").innerHTML = `${currSize[1]}`
        document.querySelector(".views .img-wrapper span.center").innerHTML = `${currSize[2]}`

  });
});

